import { Flex, Group } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import React from "react";

interface FormModalFooterProps {
  children: React.ReactNode;
  info?: string;
  justify?: string;
}

const FormModalFooter: React.FC<FormModalFooterProps> = ({
  children,
  info = "",
  justify = "space-between",
}) => {
  return (
    <Group className="bg-white mih-h-[77px] p-5 border-t border-gray-accent">
      <Flex gap="xs" direction="column" className="w-full">
        {info && (
          <Flex
            justify="center"
            className="-m-5 mb-1 text-xs text-white bg-blue leading-loose"
          >
            <IconAlertTriangle
              height={"22px"}
              width={"22px"}
              className="mr-2"
            />{" "}
            {info}
          </Flex>
        )}
        <Group justify={justify}>{children}</Group>
      </Flex>
    </Group>
  );
};

export default FormModalFooter;
